import replaceProductInUrl from './replaceProductInUrl';
export default _ref => {
  let {
    currentProject,
    redirectToProductIds,
    currentToolId
  } = _ref;
  if (redirectToProductIds && currentToolId) {
    const alternativeProduct = currentProject === null || currentProject === void 0 ? void 0 : currentProject.products.find(p => redirectToProductIds.includes(p.key) && (p === null || p === void 0 ? void 0 : p.tools.find(_ref2 => {
      let {
        key
      } = _ref2;
      return key === currentToolId;
    })));
    const alternativeTool = alternativeProduct === null || alternativeProduct === void 0 ? void 0 : alternativeProduct.tools.find(_ref3 => {
      let {
        key
      } = _ref3;
      return key === currentToolId;
    });
    if (alternativeTool) {
      return replaceProductInUrl(window.location.href, alternativeTool.url);
    }
  }
  return '';
};
//# sourceMappingURL=getRedirectUrlToAvailableProduct.js.map